import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function FieldsDisplay({ title, style, fields }) {
	const theme = useTheme();
	const showTitle =
		typeof theme?.customOptions?.fieldsDisplayTitle === "undefined"
			? true
			: theme.customOptions.fieldsDisplayTitle;
	const cardStyle = theme?.customOptions?.fieldsDisplayStyle || "box";

	const Wrap = ({ children }) => {
		if (cardStyle === "transparent") {
			return <Box className="fields-display transparent">{children}</Box>;
		} else {
			return (
				<Paper
					sx={(theme) => ({
						padding: theme.spacing(3),
						backgroundColor: theme.palette.grey["200"],
					})}
					className="fields-display"
				>
					{children}
				</Paper>
			);
		}
	};

	return (
		<Wrap>
			{showTitle && title && <Typography variant="h3">{title}</Typography>}
			<Box component="ul" sx={{ margin: 0, padding: 0, listStyle: "none", "& a": {color: theme.palette.link.main} }}>
				{fields
					.filter((f) => !!f.value)
					.map((f) => (
						<Box
							component="li"
							sx={(theme) => ({
								marginTop: theme.spacing(2),
								display: "flex",
								"& > *": { display: "block" },
								"& > strong": { marginRight: theme.spacing(2), minWidth: 100 },
								"&:first-child": { marginTop: 0 },
							})}
						>
							{f.label && `${f.label}`.length > 0 ? (
								<strong>{f.label} </strong>
							) : (
								""
							)}
							<span dangerouslySetInnerHTML={{ __html: f.value }} />
						</Box>
					))}
			</Box>
		</Wrap>
	);
}

export default FieldsDisplay;
